import React from 'react'
import { formTypeList } from '../../constants/form'
import WarehouseForm from './WarehouseForm'

const AddNewWarehouse = ({ setOpen }) => (
    <WarehouseForm formType={formTypeList.NEW} setOpen={setOpen} />
)

export default AddNewWarehouse
